import { Box, Button, Typography } from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

export const ContactSection = () => {
    return (
        <Box sx={{ textAlign: 'start' }}>
            <Typography variant="h5" sx={{ mb: 3, color: '#222' }}>
                Wir setzen Ihre Rechte durch - schnell, kompetent und engagiert.
            </Typography>
            <Button
                variant="contained"
                size="large"
                sx={{ px: 5, py: 1.5 }}
                component="a"
                href="mailto:info@kanzlei-imrecht.de?subject=Kontaktanfrage%20via%20kanzlei-imrecht.de&body=Sehr%20geehrte%20Frau%20Ra.%20Özcan-Ergün,"
                startIcon={<EmailOutlinedIcon />}
            >
                Jetzt Kontakt aufnehmen 
            </Button>
        </Box>
    );
};
